import axios from "axios";
import * as ActionType from "./types";

// get avatarFrame
export const getArEffects = () => (dispatch) => {
    axios
        .get(`deepAr`)
        .then((res) => {
            if (res.data.status) {
                dispatch({
                    type: ActionType.GET_AR_EFFECTS,
                    payload: res.data.data,
                });
            }
        })
        .catch((error) => console.log("error", error));
};

// Create avatarFrame
export const createArEffect = (data) => (dispatch) => {
    axios
        .post(`deepAr`, data)
        .then((res) => {
            if (res.data.status) {

                dispatch({
                    type: ActionType.CREATE_AR_EFFECT,
                    payload: res.data.data,
                });
            }
        })
        .catch((error) => console.log("error", error));
};

export const updateArEffect = (id, data) => (dispatch) => {
    console.log("updateArEffect", id, data);
    axios
        .post(`deepAr/${id}`, data)
        .then((res) => {
            console.log("updateArEffect response", res);
            if (res.data.status) {
                console.log("res.data", res.data.data);
                dispatch({
                    type: ActionType.UPDATE_AR_EFFECT,
                    payload: { data: res.data.data, id },
                });
            }
        })
        .catch((error) => console.log("errors", error));
};

export const deleteArEffect = (id) => (dispatch) => {
    axios
        .delete(`deepAr/${id}`)
        .then((res) => {
            if (res.data.status) {

                dispatch({ type: ActionType.DELETE_AR_EFFECT, payload: id });
            }
        })
        .catch((error) => console.log("error", error));
};
